import React, { useEffect, useState, useRef, useCallback } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Typography, Button, Card, Box, InputAdornment, TextField, Grid, CardContent } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { MaterialReactTable } from 'material-react-table';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from 'react-router-dom';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@mui/styles';
import { Autocomplete } from '@mui/material';
import { debounce, throttle } from 'lodash';
import AddCustomNotification from './AddCustomNotification';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import apiService from '../../core/services/apiService';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
import '../../App.css'
const useStyles = makeStyles((theme) => ({
    LeadTable: {
        // [theme.breakpoints.down('md')]: {
        //     width: '1070px',
        // },
        // [theme.breakpoints.between('md', 'xmd')]: {
        //     width: '1100px',
        // },
    },
    customAutoCompleteStyle: {
        width: '250px',
        [theme.breakpoints.down('md')]: {
            width: '200px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '200px',
        },
    },
}));
const CustomNotification = () => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const [rowSelection, setRowSelection] = useState({});
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [customType, setCustomType] = useState('');
    const [CustomNotification, setCustomNotification] = useState([]);
    const [PrevCustomNotifications, setPrevCustomNotifications] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [GetVersionsDeviceOs, setGetVersionsDeviceOs] = useState([]);
    const [SubscriptionType, setSubscriptionType] = useState([]);
    const [OsDevice, setOsDevice] = useState('');
    const [SubscriptionDevice, setSubscriptionDevice] = useState('');
    const [AppVersions, setAppVersions] = useState([]);
    const [appValue, setAppValue] = useState(null);
    const [filteredAppVersions, setFilteredAppVersions] = useState([]);
    const [logOutModal, setLogOutModal] = React.useState(false);

    const abortControllerRef = useRef(null);

    const handleOpen = () => {
        const selectedRowIds = Object.keys(rowSelection);
        if (selectedRowIds?.length === 0) {
            toast.error('Please select at least one user.');
            return;
        }
        const selectedRows = PrevCustomNotifications?.filter((row) =>
            selectedRowIds.includes(row?.id?.toString()) 
        );
        const validSelectedRows = selectedRows?.filter(row => row !== undefined);
        setSelectedIds(validSelectedRows);
        setOpen(true);
    };
    const options = [
        { label: 'ICA Agent', value: 'isa_agent' },
        { label: 'Agent', value: 'agent' },
        { label: 'Customer', value: 'customer' },
    ];
    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const columns = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 20,
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 20,
            enableSorting: false,
        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            size: 80,
            enableSorting: false,
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 80,
        },
        {
            accessorKey: 'last_login',
            header: 'Last Login',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ row }) => {
                const dateString = row?.original?.last_login;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return 'Never Logged In';
            },
        },
        {
            accessorKey: 'subscription_type',
            header: 'Subscription Type',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const subscriptionType = row?.original?.subscription_type;
                const capitalFirstLetter = (type) => {
                    switch (type) {
                        case 'premier':
                            return 'Premier';
                        case 'elite':
                            return 'Elite';
                        case 'founder':
                            return 'Founder';
                        default:
                            return 'Unknown';
                    }
                };
                return <span>{capitalFirstLetter(subscriptionType ? subscriptionType : 'Not Subscribed')}</span>;
            },
        },
        {
            Cell: ({ row }) => {
                const userType = row?.original?.user_type;
                // Function to map user_type to the desired display label
                const getUserTypeLabel = (type) => {
                    switch (type) {
                        case 'agent':
                            return 'Agent';
                        case 'isa_agent':
                            return 'ICA Agent';
                        case 'customer':
                            return 'Customer';
                        default:
                            return 'Unknown'; // Fallback for unknown values
                    }
                };
                return <span>{getUserTypeLabel(userType)}</span>;
            },
            header: 'User Type',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 80,
        },
        {
            accessorKey: 'os_version',
            header: 'OS Version',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 80,
        },
        {
            accessorKey: 'app_version',
            header: 'App Version',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 80,
        },
        {
            Cell: ({ row }) => {
                const deviceType = row?.original?.device_os;
                // Function to map user_type to the desired display label
                const getUserDeviceType = (type) => {
                    switch (type) {
                        case 'ios':
                            return 'IOS';
                        case 'android':
                            return 'Android';
                        default:
                            return 'Unknown'; // Fallback for unknown values
                    }
                };
                return <span>{getUserDeviceType(deviceType)}</span>;
            },
            header: 'Device OS',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 80,
        },
    ];

    const getCustomNotification = async (customType = '', searchTerm = '', OsDevice = '', SubscriptionDevice = '', appValue = '') => {
        try {
            setLoading(true);
            const res = await LeadService.GetCustomNotification(customType, searchTerm, OsDevice, SubscriptionDevice, appValue?.title);
            if (res?.data?.success) {
                setCustomNotification(res?.data?.data);
                setPrevCustomNotifications(prevData => {
                    return res?.data?.data && res?.data?.data.length > 0
                        ? [...prevData, ...res?.data?.data]
                        : prevData; // Keep the previous data if no new data is present
                })
                return;
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };

    const GetIosAndroidSubscriptionVersions = async () => {
        try {
            const res = await LeadService.GetOsAndroidSubscriptionTypeVersion();
            if (res?.data?.success) {
                const appVersions = res?.data?.app_versions;
                setGetVersionsDeviceOs(res?.data?.device_os);
                setSubscriptionType(res?.data?.subscription_types);
                const categorizedVersions = appVersions.map((version) => {
                    return {
                        title: version,
                        firstLetter: version.startsWith('v') ? 'IOS' : 'Android',
                    };
                });
                setAppVersions(categorizedVersions);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    const throttledGetCustomNotification = useCallback(
        throttle((customType, searchTerm, OsDevice, SubscriptionDevice, appValue, signal) => {
            getCustomNotification(customType, searchTerm, OsDevice, SubscriptionDevice, appValue, signal);
        }, 2000),
        []
    );

    const fetchGetNotification = useCallback(
        debounce((customType, searchTerm, OsDevice, SubscriptionDevice, appValue) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetCustomNotification(customType, searchTerm, OsDevice, SubscriptionDevice, appValue, abortController.signal);
        }, 300),
        [throttledGetCustomNotification]
    );

    useEffect(() => {
        fetchGetNotification(customType, searchTerm, OsDevice, SubscriptionDevice, appValue);
    }, [customType, searchTerm, OsDevice, SubscriptionDevice, appValue, fetchGetNotification]);
    useEffect(() => {
        GetIosAndroidSubscriptionVersions();
    }, []);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const HandleChangeCustomType = (event, newValue) => {
        setCustomType(newValue?.value);
        // setRowSelection([])
    };

    const handleClear = () => {
        setSearchTerm('');
    };

    const HandleChangeOSDevice = (event, newValue) => {
        setOsDevice(newValue);
        // setRowSelection({});
    };
    const HandleChangeSubscriptionType = (event, newValue) => {
        setSubscriptionDevice(newValue);
        // setRowSelection({});
    };

    const HandleChangeAppVersion = (event, newValue) => {
        setAppValue(newValue);
        // setRowSelection({});
    };

    useEffect(() => {
        if (!OsDevice || OsDevice === 'web') {
            setFilteredAppVersions(AppVersions);
        } else {
            const filterByOS = OsDevice === 'ios' ? 'IOS' : 'Android';
            const filtered = AppVersions.filter((version) => version.firstLetter === filterByOS);
            setFilteredAppVersions(filtered);
        }
    }, [OsDevice, AppVersions]);

    return (
        <div>
            <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
            <ScrollAnimation animateIn="fadeIn">
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
                    <Box>
                        <Typography className='services-animated-text'>Push Notification</Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            className='main-primary-btn'
                            onClick={handleOpen}
                        >
                            Send Push Notification
                        </Button>
                    </Box>
                </div>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '5px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    <Autocomplete
                        options={options}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => <TextField {...params} label="User Type" />}
                        value={options.find((option) => option.value === customType) || null}
                        onChange={HandleChangeCustomType}
                        className={classes.customAutoCompleteStyle}
                        sx={{
                            width: {
                                xs: "150px",
                                sm: "200px",
                                md: "250px"
                            },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                            },
                        }}
                    />
                    <Autocomplete
                        options={GetVersionsDeviceOs}
                        getOptionLabel={(option) => option.charAt(0).toUpperCase() + option.slice(1)}
                        renderInput={(params) => <TextField {...params} label="Device OS" />}
                        value={GetVersionsDeviceOs?.find((version) => version === OsDevice) || null}
                        onChange={HandleChangeOSDevice}
                        disabled={isLoading}
                        className={classes.customAutoCompleteStyle}
                        sx={{
                            width: {
                                xs: "150px",
                                sm: "200px",
                                md: "250px"
                            },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                            },
                        }}
                    />
                    <Autocomplete
                        options={SubscriptionType}
                        getOptionLabel={(option) => option.charAt(0).toUpperCase() + option.slice(1)}
                        renderInput={(params) => <TextField {...params} label="Subscription Types" />}
                        value={SubscriptionType?.find((subscription) => subscription === SubscriptionDevice) || null}
                        onChange={HandleChangeSubscriptionType}
                        disabled={isLoading}
                        className={classes.customAutoCompleteStyle}
                        sx={{
                            width: {
                                xs: "150px",
                                sm: "200px",
                                md: "250px"
                            },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                            },
                        }}
                    />
                    <Autocomplete
                        options={filteredAppVersions.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                        groupBy={(option) => option.firstLetter}
                        value={appValue}
                        getOptionLabel={(option) => option.title}
                        onChange={HandleChangeAppVersion}
                        className={classes.customAutoCompleteStyle}
                        renderInput={(params) => <TextField {...params} label="App Version" />}
                        sx={{
                            width: {
                                xs: "150px",
                                sm: "200px",
                                md: "250px"
                            },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                            },
                        }}
                    />
                    <TextField
                        value={searchTerm}
                        onChange={handleSearchChange}
                        placeholder="Search by name, email "
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleClear} aria-label="clear search">
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        variant="outlined"
                        className={classes.customAutoCompleteStyle}
                        sx={{
                            width: {
                                xs: "150px",
                                sm: "200px",
                                md: "250px"
                            },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                            },
                        }}
                    />
                </div>
                <ThemeProvider theme={theme}>
                    <GlobalStyles
                        styles={{
                            '::-webkit-scrollbar': {
                                width: '14px', // Set the desired width for the scrollbar
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                borderRadius: '10px', // Set the border radius for a rounded effect
                            },
                        }}
                    />
                    <div>
                        <div className={classes.LeadTable}>
                            <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                <MaterialReactTable
                                    columns={columns}
                                    data={CustomNotification}
                                    state={{ rowSelection, isLoading: isLoading }}
                                    muiCircularProgressProps={{
                                        color: 'secondary',
                                        thickness: 5,
                                        size: 55,
                                    }}
                                    muiSkeletonProps={{
                                        animation: 'pulse',
                                        height: 28,
                                    }}
                                    enablePagination={false}
                                    enableTopToolbar={true}
                                    enableDensityToggle={false}
                                    enableHiding={false}
                                    showSkeletons={false}
                                    enableColumnFilterModes={false}
                                    enableColumnActions={false}
                                    enableColumnOrdering={false}
                                    enableFullScreenToggle={false}
                                    enableColumnFilters={false}
                                    enableGlobalFilter={false}
                                    initialState={{
                                        showColumnFilters: false,
                                        showGlobalFilter: false,
                                    }}
                                    enableRowSelection={true}
                                    onRowSelectionChange={setRowSelection}
                                    getRowId={(row) => row?.id?.toString() } // Use only `id` as unique key
                                    muiTableBodyRowProps={{
                                        sx: {
                                            backgroundColor: '#f5f5f5', // Default row background color
                                            '&:nth-of-type(odd)': {
                                                backgroundColor: '#ffffff', // Alternate rows with white
                                            },
                                            '&:hover': {
                                                backgroundColor: '#e0e0e0', // Hover effect
                                                cursor: 'pointer',
                                            },
                                        },
                                    }}
                                />
                            </Card>
                        </div>

                        {/* <Pagination
                            count={totalPages}
                            color="primary"
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                        /> */}
                    </div>
                </ThemeProvider>
            </ScrollAnimation>

            <AddCustomNotification
                open={open}
                setOpen={setOpen}
                handleOpen={handleOpen}
                selectedIds={selectedIds}
                fetchGetNotification={fetchGetNotification}
                customType={customType}
                searchTerm={searchTerm}
                OsDevice={OsDevice}
                SubscriptionDevice={SubscriptionDevice}
                appValue={appValue}
                setRowSelection={setRowSelection}
                setPrevCustomNotifications={setPrevCustomNotifications}
            />
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal}/>
        </div>
    );
};

export default CustomNotification;
